export type BoardTemplate = {
  id: string
  name: string
  description: string
  emoji: string
  columns: { name: string; cards?: string[] }[]
}

export const BOARD_TEMPLATES: BoardTemplate[] = [
  {
    id: "blank",
    name: "Blank board",
    description: "Start from scratch with default columns",
    emoji: "🗒️",
    columns: [
      { name: "To Do" },
      { name: "In Progress" },
      { name: "Done" },
    ],
  },
  {
    id: "scrum-sprint",
    name: "Scrum Sprint",
    description: "Classic sprint board for agile teams",
    emoji: "⚡",
    columns: [
      { name: "Backlog", cards: ["Define acceptance criteria", "Write unit tests"] },
      { name: "Sprint", cards: ["Review design mockups"] },
      { name: "In Progress" },
      { name: "In Review" },
      { name: "Done" },
    ],
  },
  {
    id: "bug-tracker",
    name: "Bug Tracker",
    description: "Track and prioritize issues and bugs",
    emoji: "🐛",
    columns: [
      { name: "Reported", cards: ["Reproduce the bug", "Gather logs"] },
      { name: "Triaged" },
      { name: "In Fix" },
      { name: "Testing" },
      { name: "Resolved" },
    ],
  },
  {
    id: "content-calendar",
    name: "Content Calendar",
    description: "Plan and publish content across channels",
    emoji: "📅",
    columns: [
      { name: "Ideas", cards: ["Blog post: onboarding tips", "Newsletter draft"] },
      { name: "Writing" },
      { name: "Review" },
      { name: "Scheduled" },
      { name: "Published" },
    ],
  },
  {
    id: "product-roadmap",
    name: "Product Roadmap",
    description: "High-level feature planning by quarter",
    emoji: "🗺️",
    columns: [
      { name: "Now", cards: ["User authentication", "Dashboard redesign"] },
      { name: "Next" },
      { name: "Later" },
      { name: "Shipped" },
    ],
  },
  {
    id: "hiring-pipeline",
    name: "Hiring Pipeline",
    description: "Manage candidates from application to offer",
    emoji: "👥",
    columns: [
      { name: "Applied", cards: ["Review resumes", "Screen LinkedIn profiles"] },
      { name: "Phone Screen" },
      { name: "Interview" },
      { name: "Offer" },
      { name: "Hired" },
      { name: "Rejected" },
    ],
  },
  {
    id: "weekly-planner",
    name: "Weekly Planner",
    description: "Organise personal tasks day by day",
    emoji: "📋",
    columns: [
      { name: "Monday" },
      { name: "Tuesday" },
      { name: "Wednesday" },
      { name: "Thursday" },
      { name: "Friday" },
    ],
  },
  {
    id: "crm",
    name: "Sales CRM",
    description: "Track leads through your sales funnel",
    emoji: "💼",
    columns: [
      { name: "Lead", cards: ["Research prospect", "Send intro email"] },
      { name: "Qualified" },
      { name: "Proposal Sent" },
      { name: "Negotiation" },
      { name: "Closed Won" },
      { name: "Closed Lost" },
    ],
  },
]
